/* eslint-disable no-undef */
/* eslint-disable import/no-extraneous-dependencies */
import * as styled from 'styled-components';
import { normalize } from 'styled-normalize';

export default styled.createGlobalStyle`
  ${normalize}

  html {
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }

  body {
    width: 100%;
    position: relative;
    left: 0;
    -webkit-overflow-scrolling: touch;
    line-height: 1.5em;
    font-family: 'Ubuntu', sans-serif;
    font-weight: 400;
    font-size: 16px;
  }

  /* Reduce motion flag */
  @media (prefers-reduced-motion: reduce) {
    button {
      animation: none;
    }
  }

  .headline {
    font-family: 'Ubuntu', sans-serif;
    font-size: 24px;
    font-weight: 700;
    color: #111;
    border-left: 4px solid #e12827;
    padding-left: 16px;
    margin-bottom: 20px;
  }

  h4 {
    margin-bottom: 5px;
    margin-top: 40px;
  }

  svg {
    font-weight: 300;
    // font-size: 12px;
    font-family: 'Ubuntu', sans-serif;
  }

  svg .x-axis .domain {
    display: none;
  }

  svg .x-axis .tick line {
    stroke: #ccc;
  }
`;
